import { System } from 'src/app/@framework/core/clms.fw.dotnet';
import * as Domain from '../Domain';
import * as Common from '../../@framework/common';
import { CLMS  } from 'src/app/@framework/core/clms.fw.common';
import { Joove } from 'src/app/@framework/core/Joove';
import * as moment from 'moment';
import { TranslateService } from '@ngx-translate/core';
import { DataListColumnInfo, DataListColumnItemType, ListDynamicColumnValue } from '@framework/components/DataList/helpers/List.helper.classes';
import { ValueFormat } from '@framework/core/clms.fw.angular';
var numeral = require('numeral');
const VerEx = require('verbal-expressions');


export class PayrollScale  {
    _originalTypeClassName = "zERP.BO.PayrollScale";
constructor(protected translateService: TranslateService = null) {
if (translateService != null) {
PayrollScale.translate = translateService;
}
this.Versions = [];
this.Id = null;
this.Name = null;
this.Code = null;
this.Description = null;
this.SystemicType = null;
this.DefinitionLevel = null;
this._key = this.Id = 0; 
}

static translate: TranslateService;
_key: any;
private _Id:any;
get Id(): any {
    return this._Id;
  }
set Id(value: any) {
    this._Id = value;
    this._key = value;
  }
Name:any;
Code:any;
Description:any;
SystemicType:any;
DefinitionLevel:any;
Data:any;
Versions:any;
static setData = ($this, value) => {
var oldValue = $this.Data;
$this.Data = value;
if (value != null) {
}
}
static setVersions = ($this, items) => {
                if (items == null) items = [];
                if ($this.Versions == null) $this.Versions = [];

                const copyItems = Common.cloneObject(items);

                while ($this.Versions.length > 0) {
                    Domain.PayrollScale.removeVersions($this, $this.Versions[0]);
                }

                Domain.PayrollScale.addManyVersions($this, copyItems);
            }
static addManyVersions = ($this, items) => {
                if (items == null) return;
                for (let i = 0; i < items.length; i++) {
                    Domain.PayrollScale.addVersions($this, items[i]);
                }
            }
static addVersions = ($this, item) => {
                if ($this.Versions == null) $this.Versions = [];
                if (item == null || $this.Versions.indexOf(item) > -1) return;
                $this.Versions.push(item);
if (item.Scale != $this) {
Domain.PayrollScaleData.setScale(item, $this);
}
}
static addRangeVersions = ($this, items: System.Collections.List<any>) => { 
                items.forEach(item => Domain.PayrollScale.addVersions($this, item));
            }
static removeVersions = ($this, item) => {
                if ($this == null || $this.Versions == null || $this.Versions.indexOf(item) === -1) return;
                var _index = $this.Versions.indexOf(item);
                $this.Versions.splice(_index, 1);
item.Scale = null;
}
static clearVersions = ($this) => { $this.Versions = null; }

static AddScaleItem(threashold: any,value: any): any{let scale1 = new Domain.PayrollScaleItem();
scale1.ValueFrom = threashold;
scale1.Value = value;
return scale1;
}
static CloneData($this: any): any{return null;
}
static GetClassName(): any{return "PayrollScale";
}
static GetVersion($this: any, requestedDate: any,logSection: any): any{let version = $this?.Versions?.linq?.where((p) => (new Date(requestedDate).getTime()) >= (new Date(p?.ActiveFrom).getTime()))?.toArray()?.linq?.orderByDescending((p) => p?.ActiveFrom)?.toArray()?.linq?.where()?.firstOrDefault(null);
if (logSection != null) {Domain.TaskLogSection.AddMessage(logSection, Domain.TaskResultMessageSeverity.Info, CLMS.Framework.String.Format("Επιλογή έκδοσης κλίμακας '{0}' βάση ημερομηνίας {1} -> {2}", $this?.Name, requestedDate, version?.ActiveFrom));}
return version;
}

static IsNew($this: any): boolean {
                if ($this == null) return true;
                return $this.Id == null || $this.Id == 0;
            }


}